export default __webpack_public_path__ + "static/media/placeholder_dummy2016-kosmetik01-de.1b13c330.png";